import urls from '../api_urls/favorite'
import { _post } from '@/axios/request'

// 检查是否收藏
export function checkCollection (params) {
  return _post(urls.checkCollection, params)
}

// 添加收藏
export function addCollection (params) {
  return _post(urls.addCollection, params)
}

// 取消收藏
export function removeCollection (params) {
  return _post(urls.removeCollection, params)
}

// 收藏统计
export function getCollectionCounts (params) {
  return _post(urls.getCollectionCounts, params)
}

// 收藏列表
export function getCollectionList (params) {
  return _post(urls.getCollectionList, params)
}



// WEBPACK FOOTER //
// ./src/axios/api/favorite.js